import antdJA from 'antd/locale/ja_JP';
import { importAllJsonFiles } from '../../../utils/utilities';

const context = (require as any).context(`./`, false, /\.json$/);

const jaLang = {
  messages: importAllJsonFiles(context),
  antd: antdJA,
  locale: 'ja-JP',
};

export default jaLang;
